import angular from 'angular';

document.write(require('./view.html').default);
import './style.scss';

angular.module("core.application.module.modal", [
]).controller("core.application.module.modal.controller", [
    "$scope", "$controller",
    function($scope, $controller) {
        $controller("core.application.module.controller", {$scope: $scope});

        $scope.closeModal = function() {
            $scope.model.isModalVisible = false;
        };

    }
]);
